export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(url);
}

export const applySearchParamUpdate = (
  params: URLSearchParams,
  key: string,
  value: string | null | undefined,
) => {
  if (!value) params.delete(key);
  else params.set(key, value);
};
